import has from 'lodash/has';

import { sortBy } from './helpers';

export const isApiError = (
  error: unknown
): error is { 'hydra:description': string } => has(error, 'hydra:description');

export const sortByPosition = <T extends { position: number }>(
  collection: T[],
  order?: 'ASC' | 'DESC'
) => sortBy(collection, 'position', order);

export const hasNumber = (value: unknown): value is number =>
  Number.isFinite(value);

export const toUrl = (input: string | null | undefined) => {
  if (!input) {
    return null;
  }

  try {
    return new URL(input).href;
  } catch {
    return new URL(`https://${input}`).href;
  }
};
